import styled from "styled-components";

export const HeaderBox = styled.div`
  display: flex;
  height: 50px;
  width: 100%;
  align-items: center;
  background-color: ${props => props.theme.colors.headerBackground};
`;